import { Model } from "./model";


export const selectUser = (state:{app:Model}) =>  {
    return state.app.user
}
